export const DEFAULT_DUPLICATE_REQUEST_WINDOW_MS = 500;
export const DEFAULT_MAX_SENTRY_EVENTS_PER_FINGERPRINT = 3;
export const DEFAULT_MAX_TRACKED_REQUESTS = 1000;
export const DUPLICATE_REQUEST_MESSAGE = 'duplicate-request';
